import {Box} from "@mui/material"
import {FC} from "react"

export type ReponsiveImageProps = {
  imageSmallPath?: string
  imageMediumPath?: string
  imageLargePath?: string
  style?: React.CSSProperties
}

const ReponsiveImage: FC<ReponsiveImageProps> = (props) => {
  const {imageSmallPath, imageMediumPath, imageLargePath, style} = props

  return (
    <Box
      component={"div"}
      sx={{
        width: "100%",
        height: "100%",
        backgroundImage: {
          xs: `url(${imageSmallPath})`,
          sm: `url(${imageSmallPath})`,
          md: `url(${imageMediumPath})`,
          lg: `url(${imageMediumPath})`,
          xl: `url(${imageLargePath})`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      style={style}
    ></Box>
  )
}

export default ReponsiveImage
